import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { getHistory } from './interestApi';

export default function PostingHistory({ refreshKey = 0 }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getHistory(200).then(setRows).finally(() => setLoading(false));
  }, [refreshKey]);

  return (
    <Card title="Recent Interest Postings">
      <DataTable value={rows} loading={loading} paginator rows={10}
                 size="small" stripedRows
                 emptyMessage="No interest postings yet."
                 sortField="transactionDate" sortOrder={-1}>
        <Column field="accountNumber"   header="Account"     sortable />
        <Column field="transactionDate" header="Quarter End" sortable
                body={r => String(r.transactionDate).slice(0, 10)} />
        <Column field="branchCode"      header="Branch"      sortable />
        <Column field="interest"        header="Interest"    sortable
                body={r => `₹${Number(r.interest).toFixed(2)}`}
                style={{ textAlign: 'right' }} />
        <Column field="postedAt"        header="Posted At"   sortable
                body={r => new Date(r.postedAt).toLocaleString()} />
        <Column header="Type" body={() => <Tag value="INTEREST" severity="success" />} />
      </DataTable>
    </Card>
  );
}
